import {Component, Input, OnInit} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ContactsService} from '@services/administration/organization/configuration/contacts/contacts.service';
import {SupportContact} from '@models/adminstration/organization/support-contact/support-contact';

@Component({
    selector: 'scitis-support-contact',
    templateUrl: './support-contact.component.html',
    styleUrls: ['./support-contact.component.scss'],
    standalone: false
})
export class SupportContactComponent implements OnInit{

  @Input()
  organizationId: number = 0;

  closeButtonText: string = '';
  fallbackText: string = '';
  supportContacts: SupportContact[] = [];
  isLoading: boolean = true;

  constructor(private activeModal: NgbActiveModal,
              private translateService: TranslateService,
              private supportContactService: ContactsService) {
    this.closeButtonText = this.translateService.instant('Close');
    this.fallbackText = this.translateService.instant('No contact person(s) have been added yet. Please check your organisation\'s settings or contact your administrator.');
  }

  ngOnInit() {
    this.listContacts(this.organizationId);
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  get showFallBackText(): boolean {
    return !this.isLoading && (!this.supportContacts || this.supportContacts.length === 0);
  }

  private listContacts(organizationId: number) {
    this.supportContactService.listContacts(organizationId).subscribe((contacts) => {
      this.supportContacts = contacts;
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      console.log('Could not list support contacts for organization %s', organizationId, error);
    });
  }

}
